import type { iCmeOptionSetId } from "./types";

const VITE_PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
const VITE_DATA_BASE_FOLDER = import.meta.env.VITE_DATA_BASE_FOLDER;
const VITE_CME_DATA_PATH = import.meta.env.VITE_CME_DATA_PATH;
const VITE_CMS_CDN_URL = import.meta.env.VITE_CMS_CDN_URL;

// **************
// Project`
// **************
export const MAIN_CSS_CLASS_NAME = "EBRO";
export const DEFAULT_LANGUAGE = "en";

// ***************
// CMS API
// ***************
export const CMS_FIXVERSION_MANIFEST = `${VITE_CMS_CDN_URL}fixversion.json`;

// ***************
// CME API
// ***************
export const CME_ROOT_PATH = `${VITE_PUBLIC_URL}${VITE_DATA_BASE_FOLDER}${VITE_CME_DATA_PATH}/`;
export const CME_APPLICABILITY_DATA = `/cme_options.json`;
export const CME_ASSETS_DATA = `/cme_assets.json`;

// **************
// CME
// **************
export const CME_ASSET_CONTEXT_PREVIOUS = "undo";
export const CME_LOCAL_STORAGE_SELECTED_OPTIONS = "cme_local_storage_selected_options";
export const USER_COOKIE_LOCAL_DATA_ID = "ebrochure_user_cookie_data";
export const USER_COOKIE_EXTERNAL_DATA_ID = "toyota_for_you_v2";
export const USER_SHARE_LINK = "share";

export const CME_OPTIONSET_COLOUR: iCmeOptionSetId = "colour";
export const CME_OPTIONSET_TRIM: iCmeOptionSetId = "interiorTrim";
export const CME_OPTIONSET_GRADE: iCmeOptionSetId = "grade";
export const CME_OPTIONSET_TONE: iCmeOptionSetId = "tone";
export const CME_OPTIONSET_DRIVETRAIN: iCmeOptionSetId = "drivetrain";
export const CME_OPTIONSET_BODY: iCmeOptionSetId = "body";
export const CME_OPTIONSET_TRANSMISSION: iCmeOptionSetId = "transmission";
export const CME_OPTIONSET_ENGINE: iCmeOptionSetId = "engine";
export const CME_OPTIONSET_ACCESSORIES: iCmeOptionSetId = "accessories";
export const CME_OPTIONSET_ACCESSORIES_PACKS: iCmeOptionSetId = "Accessories_Pack";
export const CME_OPTIONSET_BULLBAR: iCmeOptionSetId = "Bull_Bar";
export const CME_OPTIONSET_CANOPY: iCmeOptionSetId = "Canopy";
export const CME_OPTIONSET_TRAY: iCmeOptionSetId = "Tray";
export const CME_OPTIONSET_WHEELS: iCmeOptionSetId = "wheels";
export const CME_OPTIONSET_PACKS: iCmeOptionSetId = "optionPack";
export const CME_OPTIONSET_MVOB: iCmeOptionSetId = "mvob";

export const CME_BANNER_ACCESSORIES_EXTERIOR_GROUP_NAME = "Exterior accessories";
export const CME_BANNER_ACCESSORIES_INTERIOR_GROUP_NAME = "Interior accessories";

export const CME_MVOB_LENGTH = 9;
export const CME_INTERIOR_TRIM_LENGTH = 4;
export const CME_COLOUR_LENGTH = 3;
export const CME_MATERIAL_CODE_LENGTH = 16;

// **************
// CMS
// **************
export const CMS_ERROR_CTA_START = "start";
export const CMS_ERROR_CTA_BROWSE_RANGE = "browse_range";
export const CMS_ERROR_CTA_DEALERSHIP = "dealership";

export const CMS_LANGAUGE_CODE = "language_code";
export const CMS_PAGES = "pages";
export const CMS_SILOS = "silos";
export const CMS_DATA_SOURCES = "data_sources";
export const CMS_SILO_ID = "silo_id";
export const CMS_SILO_PATH = "silo_path";
export const CMS_VEHICLE_ID = "vehicle_id";
export const CMS_DATASOURCES_PRINTPDF = "print_pdf";
export const CMS_DATASOURCES_HYBRIDENGINES = "hybrid_engines";
export const CMS_DATASOURCES_CME_OPTIONS_UI_SILO = "cme_options_ui_silo";
export const CMS_DATASOURCES_DYNAMIC_VARIABLES = "dynamic_variables";
export const CMS_DATASOURCES_VEHICLE_CARDS = "vehicle_cards";
export const CMS_DATASOURCES_ROADMAP_CARDS = "roadmap_cards";
export const CMS_DATASOURCES_EMAIL = "email";
export const CMS_DATASOURCES_KILLSWITCH = "killswitch";
export const CME_DATASOURCES_FEATURED_ACCESSORIES = "featured_accessories";
export const CME_DATASOURCES_OFFERS = "offers";
export const CMS_ALL_ENGINES = "all";

export const CMS_FEATURES_DESIGN = "design";
export const CMS_FEATURES_TECHNOLOGY = "technology";
export const CMS_FEATURES_PERFORMANCE = "performance";
export const CMS_FEATURES_SAFETY = "safety";
export const CMS_FEATURES_HYBRID = "hybrid";
export const CMS_FEATURES_ELECTRIC = "electric";
export const CMS_FEATURES_HYBRID_ELECTRIC = "hybrid electric";
export const CMS_FEATURES_POWER = "power";
export const CMS_FEATURES_GREAT_POWER = "Great power, even great ease.";
export const CMS_FEATURES_TOYOTA_BZ4X = "toyota bz4x";
export const CMS_FEATURES_ELECTRIFIED = "electrified";
export const CMS_FEATURES_PLUG_IN_HYBRID_ELECTRIC = "Plug-in Hybrid Electric";

export const CMS_SPECIFICATIONS_OVERVIEW = "overview";
export const CMS_SPECIFICATIONS_PERFORMANCE = "performance";
export const CMS_SPECIFICATIONS_INTERIOR = "interior";
export const CMS_SPECIFICATIONS_EXTERIOR = "exterior";
export const CMS_SPECIFICATIONS_MULTIMEDIA = "multimedia";
export const CMS_SPECIFICATIONS_CONNECTED_SERVICES = "connectedServices";
export const CMS_SPECIFICATIONS_SAFETY = "safety";

export const CMS_TEMPLATES_COMMERCIAL = "commercial";
export const CMS_TEMPLATES_ELECTRIC = "electric";
export const CMS_TEMPLATES_GR = "gr";
export const CMS_TEMPLATES_PASSENGER = "passenger";

export const MAKE = "Toyota";
export const VEHICLE_BZ4X = "bz4x";
export const VEHICLE_CHR = "c-hr";
export const VEHICLE_GR86 = "gr86";
export const VEHICLE_GR_COROLLA = "gr corolla";
export const VEHICLE_GR_YARIS = "gr yaris";
export const VEHICLE_YARIS_CROSS = "yaris cross";

export const VEHICLES = [VEHICLE_CHR, VEHICLE_BZ4X, VEHICLE_YARIS_CROSS];

// ***************
// PROJECT-SPECIFIC CONSTANTS
// ***************
export const ASSET_TYPE_CAV_IMAGE = "CAV_IMAGE";
export const ASSET_TYPE_CAV_SPINNER = "CAV_SPINNER";
export const ASSET_TYPE_CAV_RCR_VIDEO = "CAV_RCR_VIDEO";
export const ASSET_TYPE_IMAGE = "IMAGE";
export const ASSET_TYPE_VIDEO = "VIDEO";

export const TOAST_NOTIFICATION_TIMEOUT = 3.5; // 3500ms
export const FSL = "FSL";
export const CASH = "Cash";
export const FINANCE = "Finance";
export const NOVATED_LEASE = "Novated";
export const PRICE_UNAVAILABLE = "Price Unavailable";
export const EXCLUDES_ACCESSORIES = "Excludes Accessories";
export const NONE = "None";
export const FSL_DISCLAIMER_KEY = "TF9";
export const CONTACT_DEALER = "Contact Dealer";
export const ORDER_ONLINE = "Order online";
export const BOOK_A_TEST_DRIVE = "Book a test drive";
export const YOUR_UNIQUE_ACCESS_CODE = "Your unique access code";
export const SAVE_IMAGE = "Save image";
export const SAVE_ALL_IMAGES = "Save all images";
export const SAVING = "Saving...";
export const SUBDOMAIN_QA = "qa";

// Sticky nav items
export const NAVBAR_ALL_VEHICLES = "All vehicles";
export const NAVBAR_CUSTOMISE = "Customise";
export const NAVBAR_GALLERY = "Gallery";
export const NAVBAR_NEXT_STEPS = "Next steps";
export const NAVBAR_SAVE_AND_SHARE = "Save and share";
export const NAVBAR_VIEW_IN_AR = "View in AR";

// ***************
// QA disable feature param
// ***************
export const QA_DISABLE_URL_PARAM = "QA_DISABLE";

// ***************
// QA TESTING IDs (alphabetical order by context-elementType-target)
// ***************
export const QA_ADVANTAGES_MODAL_TAB = "advantages-modal-tab";
export const QA_ADVANTAGES_TILE_BUTTON_LEARN_MORE = "advantages-tile-button-learn-more";

export const QA_ALL_VEHICLES_BUTTON_CATEGORY = "all-vehicles-button-category";
export const QA_ALL_VEHICLES_BUTTON_EXPLORE = "all-vehicles-button-explore";
export const QA_ALL_VEHICLES_GRID_MODAL = "all-vehicles-grid";
export const QA_ALL_VEHICLES_GRID_ITEM = "all-vehicles-grid-item";
export const QA_ALL_VEHICLES_GRID_ITEM_CARD = "all-vehicles-grid-item-card";

export const QA_CAV_SPINNER = "cav-spinner";
export const QA_CAV_SPINNER_CONTAINER = "cav-spinner-container";

export const QA_CME_BANNER_BUTTON_ACCESS_CODE = "cme-banner-button-access-code";
export const QA_CME_BANNER_BUTTON_CONTACT_DEALER = "cme-banner-button-contact-dealer";
export const QA_CME_BANNER_BUTTON_TEST_DRIVE = "cme-banner-button-test-drive";
export const QA_CME_BANNER_SUMMARY_ITEM = "cme-banner-summary-item";
export const QA_CME_BANNER_SUMMARY_EXTERIOR = "cme-banner-summary-item-exterior";
export const QA_CME_BANNER_SUMMARY_INTERIOR = "cme-banner-summary-item-interior";

export const QA_CONFIGURATOR = "configurator";
export const QA_CONFIGURATOR_ACCESSORY = "configurator-accessory";
export const QA_CONFIGURATOR_ACCESSORY_PACK = "configurator-accessory-pack";
export const QA_CONFIGURATOR_BUTTON_AR = "configurator-button-ar";
export const QA_CONFIGURATOR_BUTTON_CME = "configurator-button-cme";
export const QA_CONFIGURATOR_BUTTON_MENU = "configurator-button-menu";
export const QA_CONFIGURATOR_BUTTON_MENU_VEHICLE = "configurator-button-menu-vehicle";
export const QA_CONFIGURATOR_BUTTON_MENU_ACCESSORIES =
  "configurator-button-menu-accessories";
export const QA_CONFIGURATOR_DROPDOWN_ACCESSORY = "configurator-dropdown-accessory";
export const QA_CONFIGURATOR_DROPDOWN_BULLBAR = "configurator-dropdown-bullbar";
export const QA_CONFIGURATOR_DROPDOWN_CANOPY = "configurator-dropdown-canopy";
export const QA_CONFIGURATOR_DROPDOWN_TRAY = "configurator-dropdown-tray";
export const QA_CONFIGURATOR_GRADE_FLAG = "configurator-grade-flag";
export const QA_CONFIGURATOR_GRADE_FLAG_DOT = "configurator-grade-flag-dot";
export const QA_CONFIGURATOR_GRADE_FLAG_LABEL = "configurator-grade-flag-label";
export const QA_CONFIGURATOR_GRADE_PP_DISCLAIMER = "configurator-grade-pp-disclaimer";
export const QA_CONFIGURATOR_MENU_OPTION_COLOUR = "configurator-menu-option-colour";
export const QA_CONFIGURATOR_MENU_OPTION_COLOUR_TITLE =
  "configurator-menu-option-colour-title";
export const QA_CONFIGURATOR_MENU_OPTION_THUMB_TEXT = "configurator-thumb-text-container";
export const QA_CONFIGURATOR_ICON_SELECTED = "configurator-icon-selected";
export const QA_CONFIGURATOR_OPTIONS_CONTAINER = "configurator-options-container";
export const QA_CONFIGURATOR_PP_DISCLAIMER = "configurator-pp-disclaimer"; // Pre-production disclaimer
export const QA_CONFIGURATOR_SPINNER_CONTAINER = "configurator-spinner-container";
export const QA_CONFIGURATOR_SPINNER_ICON_360 = "configurator-spinner-icon-360";

export const QA_CHARGING_MODAL_TAB = "charging-modal-tab";
export const QA_CHARGING_BUTTON_LEARN_MORE = "charging-button-learn-more";

export const QA_DEALER_BUTTON_ACCESS_CODE = "dealer-button-access-code";
export const QA_DEALER_BUTTON_EMAIL = "dealer-button-email";
export const QA_DEALER_BUTTON_NEXT_STEPS = "dealer-button-next-steps";
export const QA_DEALER_BUTTON_PHONE = "dealer-button-phone";
export const QA_DEALER_CARD = "dealer-card";

export const QA_DISCLAIMERS_LIST = "disclaimers-list";
export const QA_DISCLAIMERS_BUTTON = "disclaimers-button";

export const QA_ERROR_MESSAGE_CONTAINER = "error-message-container";

export const QA_FEATURES_BUTTON_AR = "features-button-ar";
export const QA_FEATURES_BUTTON_VIEW = "features-button-view";
export const QA_FEATURES_MODAL_TAB = "features-modal-tab";
export const QA_FEATURES_FOOTER = "features-footer";

export const QA_HOME_GAZOO_HEADING = "home-gazoo-heading";
export const QA_HOME_GAZOO_BODY = "home-gazoo-body";

export const QA_GENUINE_ACCESSORIES_BUTTON_EXPLORE = "genuine-accessories-button-explore";
export const QA_GENUINE_ACCESSORIES_ICON_SELECTED = "genuine-accessories-icon-selected";
export const QA_GENUINE_ACCESSORIES_THUMB_LARGE = "genuine-accessories-thumb-large";

export const QA_HEADER_MAIN = "header-main";

export const QA_HOME_FEATURED_ACCESSORIES_DISCLAIMER =
  "home-featured-accessories-disclaimer";
export const QA_HOME_CAV_PP_DISCLAIMER = "home-cav-pp-disclaimer";
export const QA_HOME_FOOTER = "home-footer";
export const QA_HOME_MOSAIC_ASSET_DISCLAIMER = "home-mosaic-asset-disclaimer"; // Pre-production disclaimer
export const QA_HOME_MOSAIC_PP_DISCLAIMER = "home-mosaic-pp-disclaimer"; // Pre-production disclaimer
export const QA_HOME_PRICING_TAB = "home-pricing-tab";
export const QA_HOME_RCR_PP_DISCLAIMER = "home-rcr-pp-disclaimer";

export const QA_ICON_GAZOO = "icon-gazoo";
export const QA_ICON_OWAF = "icon-owaf";

export const QA_MODAL_CONTENT = "modal-content";
export const QA_MODAL_BUTTON_CLOSE = "modal-button-close";
export const QA_MODAL_BUTTON_NEXT = "modal-button-next";
export const QA_MODAL_BUTTON_PREVIOUS = "modal-button-previous";
export const QA_MODAL_HEADER = "modal-header";
export const QA_MODAL_WRAPPER = "modal-wrapper";

export const QA_NAVBAR = "navbar";
export const QA_NAVBAR_BUTTON_ALL_VEHICLES = "navbar-button-all-vehicles";
export const QA_NAVBAR_BUTTON_AR = "navbar-button-ar";
export const QA_NAVBAR_BUTTON_DROPDOWN = "navbar-button-dropdown";
export const QA_NAVBAR_BUTTON_HOME = "navbar-button-home";
export const QA_NAVBAR_LINK = "navbar-link";
export const QA_NAVBAR_LINK_AR = "navbar-link-ar"; // Sticky nav dropdown menu AR link
export const QA_NAVBAR_LINK_BUTTON = "navbar-link-button";
export const QA_NAVBAR_LINK_LABEL = "navbar-link-label";

export const QA_NEXT_STEPS_ACCORDION_ICON_MINUS = "next-steps-accordion-icon-minus";
export const QA_NEXT_STEPS_ACCORDION_ICON_PLUS = "next-steps-accordion-icon-plus";
export const QA_NEXT_STEPS_ACCORDION_ITEM = "next-steps-accordion-item";
export const QA_NEXT_STEPS_ACCORDION_ITEM_BUTTON = "next-steps-accordion-item-button";
export const QA_NEXT_STEPS_ACCORDION_ITEM_CONTENT = "next-steps-accordion-item-content";
export const QA_NEXT_STEPS_BUTTON_ACCESS_CODE = "next-steps-button-access-code";
export const QA_NEXT_STEPS_BUTTON_CARD = "next-steps-button-card";
export const QA_NEXT_STEPS_BUTTON_CONTACT_DEALER = "next-steps-button-contact-dealer";
export const QA_NEXT_STEPS_BUTTON_REPAYMENT = "next-steps-button-repayment";
export const QA_NEXT_STEPS_BUTTON_SPECIAL_OFFER = "next-steps-button-special-offer";
export const QA_NEXT_STEPS_DROPDOWN_LEASE = "next-steps-dropdown-lease";
export const QA_NEXT_STEPS_DROPDOWN_USAGE = "next-steps-dropdown-usage";
export const QA_NEXT_STEPS_PP_DISCLAIMER = "next-steps-pp-disclaimer"; // Pre-production disclaimer
export const QA_NEXT_STEPS_PRICING_TAB = "next-steps-pricing-tab";
export const QA_NEXT_STEPS_SUMMARY_INFO = "next-steps-summary-info";
export const QA_NEXT_STEPS_SUMMARY_WRAPPER = "next-steps-summary-wrapper";

export const QA_SIDEBAR_ONBOARDING_POSTCODE_ERROR = "sidebar-onboarding-postcode-error";
export const QA_SIDEBAR_ONBOARDING_DEALER_CARD = "sidebar-onboarding-dealer-card";
export const QA_SIDEBAR_ONBOARDING_BUTTON_GO = "sidebar-onboarding-button-go";
export const QA_SIDEBAR_ONBOARDING_BUTTON_SKIP = "sidebar-onboarding-button-skip";
export const QA_SIDEBAR_ONBOARDING_INPUT_NAME = "sidebar-onboarding-input-name";
export const QA_SIDEBAR_ONBOARDING_INPUT_POSTCODE = "sidebar-onboarding-input-postcode";
export const QA_SIDEBAR_ONBOARDING_POSTCODE_SUGGESTION =
  "sidebar-onboarding-postcode-suggestion";

export const QA_SIDEBAR_BUTTON_BACK = "sidebar-button-back";
export const QA_SIDEBAR_BUTTON_BROWSE_DEALERS = "sidebar-button-browse-dealers";
export const QA_SIDEBAR_BUTTON_COPY = "sidebar-button-copy";
export const QA_SIDEBAR_BUTTON_EMAIL = "sidebar-button-email";
export const QA_SIDEBAR_BUTTON_EMAIL_SUBMIT = "sidebar-button-email-submit";
export const QA_SIDEBAR_BUTTON_PDF = "sidebar-button-pdf";

export const QA_SIDEBAR_INPUT_EMAIL = "sidebar-input-email";
export const QA_SIDEBAR_INPUT_FIRST_NAME = "sidebar-input-first-name";
export const QA_SIDEBAR_INPUT_LAST_NAME = "sidebar-input-last-name";
export const QA_SIDEBAR_INPUT_PHONE = "sidebar-input-phone";
export const QA_SIDEBAR_FORM_EMAIL = "sidebar-form-email";

export const QA_SPECIFICATIONS_ACCORDION = "specifications-accordion";
export const QA_SPECIFICATIONS_ACCORDION_ITEM_BUTTON =
  "specifications-accordion-item-button";
export const QA_SPECIFICATIONS_ACCORDION_ITEM = "specifications-accordion-item";
export const QA_SPECIFICATIONS_ACCORDION_ITEM_CONTENT =
  "specifications-accordion-item-content";
export const QA_SPECIFICATIONS_CONTAINER = "specifications-container";
export const QA_SPECIFICATIONS_BUTTON_SELECT_VEHICLE =
  "specifications-button-select-vehicle";
export const QA_SPECIFICATIONS_DROPDOWN = "specifications-dropdown";
export const QA_SPECIFICATIONS_FOOTER = "specifications-footer";
export const QA_SPECIFICATIONS_GRADE_ITEM = "specifications-grade-item";

export const QA_SPECIFICATIONS_LIST_BUTTON = "specifications-list-button";

export const QA_SWIPER_BUTTON_NEXT = "swiper-button-next";
export const QA_SWIPER_BUTTON_PREVIOUS = "swiper-button-previous";
export const QA_SWIPER_NAV = "swiper-nav";
export const QA_SWIPER_NAV_CONTENT = "swiper-nav-content";
export const QA_SWIPER_NAV_MENU = "swiper-nav-menu";
export const QA_SWIPER_NAV_MENU_TAB = "swiper-nav-menu-tab";
export const QA_SWIPER_NAV_MENU_TAB_TITLE = "swiper-menu-tab-title";
export const QA_SWIPER_NAV_SLIDE = "swiper-nav-slide";
export const QA_SWIPER_SLIDES = "swiper-slides";
export const QA_SWIPER_SLIDES_ITEM_ASSET = "swiper-slides-item-asset";
export const QA_SWIPER_SLIDES_ITEM_FOOTER = "swiper-slides-item-footer";
export const QA_SWIPER_SLIDES_ITEM_HEADER = "swiper-slides-item-header";
export const QA_SWIPER_SLIDES_ITEM_KEY_POINTS = "swiper-slides-item-key-points";

export const QA_TOAST = "toast";

export const QA_QTVR_OVERLAY_BUTTON = "qtvr-overlay-button";
export const QA_QUICK_LINKS = "quick-links";

// **************
// Kill Switch features
// **************
export const FEATURE_ACCESSORIES_CAROUSEL = "feature_acc_carousel";
export const FEATURE_ACCESSORIES_CONFIGURATOR = "feature_acc_configurator";
export const FEATURE_AR = "feature_ar";
export const FEATURE_BOOK_TEST_DRIVE = "feature_book_test_drive";
export const FEATURE_CME_OPTIONS_UI_SILO = "feature_cme_options_ui_silo";
export const FEATURE_CONFIGURATOR_GRADE_FLAGS = "feature_configurator_grade_flags";
export const FEATURE_FSL = "feature_fsl";
export const FEATURE_PRICING = "feature_pricing";
export const FEATURE_RCR_VIDEO = "feature_rcr";
export const FEATURE_SECTION_PREVIEW = "feature_section_preview";

export const CMS_CME_OPTIONS_FALLBACK = "fallback"; // fallback key to be looked at when no value is availabled in CME

// **************
// UiMShareFlyout SIDEBAR VIEWS
// **************
export const INITIAL_VIEW = "initial";

// **************
// Anchor link IDs
// **************
export const ANCHOR_LINK_DEALER_CARD = "dealerCard";

// ***************
// PROJECT-SPECIFIC COMPONENT ID'S
// ***************

// ATOMS

// MOLECULES
export const UI_MOLECULE_ALERT = "UimAlert";
export const UI_MOLECULE_BUTTON_ACCESS_CODE = "UimButtonAccessCode";
export const UI_MOLECULE_BUTTON_THUMB = "UimButtonThumb";
export const UI_MOLECULE_BUTTON_THUMB_TEXT = "UimButtonThumbText";
export const UI_MOLECULE_CARD_DEALER = "UimCardDealer";
export const UI_MOLECULE_CARD_DEALER_LARGE = "UimCardDealerLarge";
export const UI_MOLECULE_CARD_ICON = "UimCardIcon";
export const UI_MOLECULE_CARD_ICON_BULLET = "UimCardIconBullet";
export const UI_MOLECULE_CARD_IMG = "UimCardImg";
export const UI_MOLECULE_CARD_WRAPPER = "UimCardWrapper";
export const UI_MOLECULE_DROPDOWN = "UimDropdown";
export const UI_MOLECULE_ERROR_MESSAGE = "UimErrorMessage";
export const UI_MOLECULE_FOOTER_MAIN = "UimFooterMain";
export const UI_MOLECULE_HEADER_MAIN = "UimHeaderMain";
export const UI_MOLECULE_HEADER_TITLE = "UimHeaderTitle";
export const UI_MOLECULE_INTRO_HERO = "UimIntroHero";
export const UI_MOLECULE_LINK = "UimLink";
export const UI_MOLECULE_QUICK_LINKS = "UimQuickLinks";
export const UI_MOLECULE_LIST_IDX_COLLAPSIBLE = "UimListIdxCollapsible";
export const UI_MOLECULE_MENU_NAV_SWIPER = "UimMenuNavSwiper";
export const UI_MOLECULE_MENU_OPTION_SET_COLOUR = "UimMenuOptionSetColour";
export const UI_MOLECULE_MENU_OPTION_SET_THUMB = "UimMenuOptionSetThumb";
export const UI_MOLECULE_MENU_OPTION_SET_THUMB_TEXT = "UimMenuOptionSetThumbText";
export const UI_MOLECULE_MOSAIC = "UimMosaic";
export const UI_MOLECULE_SWIPER = "UimSwiper";
export const UI_MOLECULE_SWIPER_NAV = "UimSwiperNav";
export const UI_MOLECULE_SWIPER_SLIDES = "UimSwiperSlides";
export const UI_MOLECULE_SWIPER_SLIDES_ITEM = "UimSwiperSlidesItem";
export const UI_MOLECULE_TABLE = "UimTable";
export const UI_MOLECULE_TEXT_HIGHLIGHTS = "UimTextHighlights";
export const UI_MOLECULE_TEXT_TITLE_DESCRIPTION = "UimTextTitleDescription";
export const UI_MOLECULE_TEXT_TITLE_DESCRIPTION_ICON = "UimTextTitleDescriptionIcon";
export const UI_MOLECULE_THUMB_LARGE = "UimThumbLarge";
export const UI_MOLECULE_TILE = "UimTile";
export const UI_MOLECULE_TILE_CONTENT = "UimTileContent";
export const UI_MOLECULE_TOAST = "UimToast";
export const UI_MOLECULE_TOP_HEADER = "UimTopHeader";
export const UI_MOLECULE_SPECIAL_OFFERS = "UimSpecialOffers";

// ORGANISMS
export const UI_ORGANISM_ACCESSORIES = "UioAccessories";
export const UI_ORGANISM_FEATURED_ACCESSORIES = "UioFeaturedAccessories";
export const UI_ORGANISM_LIST_CARD_ICON_BULLETS = "UioListCardIconBullets";
export const UI_ORGANISM_CONFIGURATOR_SAVE = "UioConfiguratorSave";
export const UI_ORGANISM_DEALERSHIP_TILES = "UioDealershipTiles";
export const UI_ORGANISM_FULL_SERVICE_LEASE = "UioFullServiceLease";
export const UI_ORGANISM_SECTION_ACCESSORIES = "UioSectionAccessories";
export const UI_ORGANISM_SECTION_CME_BANNER = "UioSectionCMEBanner";
export const UI_ORGANISM_SECTION_PREVIEW = "UioSectionPreview";
export const UI_ORGANISM_SUMMARY = "UioSummary";
export const UI_ORGANISM_SWIPER_GALLERY = "UioSwiperGallery";

// MODULES
export const UI_MODULE_BUTTON_CONTACT_DEALER = "UiMButtonContactDealer";
export const UI_MODULE_BUTTON_REPAYMENT = "UiMButtonRepayment";
export const UI_MODULE_CME_IMAGE = "UiMCMEImage";
export const UI_MODULE_CME_QTVR = "UiMCMEQtvr";
export const UI_MODULE_CME_RCR_VIDEO = "UiMCMERcrVideo";
export const UI_MODULE_CONFIGURATOR = "UiMConfigurator";
export const UI_MODULE_GAZOO_RACING = "UiMGazooRacing";
export const UI_MODULE_DEALER_LOCATOR = "UiMDealerLocator";
export const UI_MODULE_MENU_STICKY = "UiMMenuSticky";
export const UI_MODULE_NAME_INPUT = "UiMNameInput";
export const UI_MODULE_PRICING = "UiMPricing";
export const UI_MODULE_PRICING_LARGE = "UiMPricingLarge";
export const UI_MODULE_QR_CODE_OVERLAY = "UiMQRCodeOverlay";
export const UI_MODULE_ROAD_MAP_CARDS = "UiMRoadMapCards";
export const UI_MODULE_SHARE_FLYOUT = "UiMShareFlyout";
export const UI_MODULE_SPECIFICATIONS_LIST = "UiMSpecificationsList";
export const UI_MODULE_SPECIFICATIONS = "UiMSpecifications";
export const UI_MODULE_VEHICLE_SELECTOR = "UiMVehicleSelector";

// Configurator state
export const MAIN_CATEGORY_VEHICLE = "Vehicle";
export const MAIN_CATEGORY_ACCESSORIES = "Accessories";
export const ACCESSORY_CATEGORY_EXTERIOR = "Exterior";
export const ACCESSORY_CATEGORY_INTERIOR = "Interior";
